import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { getUserList } from "../../Redux/authentication/auth.action";
import { GET_NOTIFICATION } from "../../utils/api";

const HeaderBar = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state?.AuthManager?.userDetails);

  console.log("test");

  const [role, setRole] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showAll, setShowAll] = useState(false);

  const [mood, setMood] = useState("happy");

  const notificationRef = useRef(null);
  const lastIdsRef = useRef(new Set());

  useEffect(() => {
    dispatch(getUserList());
    const r = localStorage.getItem("role");
    if (r) setRole(+r);
  }, [dispatch]);

  const fullName = useMemo(() => {
    if (!userDetail) return "";
    const cap = (s) => s?.charAt(0).toUpperCase() + s?.slice(1);
    return `${cap(userDetail.first_name || "")} ${cap(
      userDetail.last_name || "",
    )}`;
  }, [userDetail]);

  /* --------------------------------------- UNREAD COUNT (MEMOIZED) ----------------------------- */

  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.is_read).length,
    [notifications],
  );

  /* ---------------------------------- FETCH NOTIFICATIONS --------------------------------------- */
  const fetchNotifications = useCallback(async () => {
    const token = localStorage.getItem("access_token");

    try {
      const res = await fetch(GET_NOTIFICATION, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();
      const list = data?.notifications || [];

      // Locally-persisted read ids (since there's no backend "mark as read" yet)
      const readIds = new Set(
        JSON.parse(localStorage.getItem("read_notification_ids") || "[]"),
      );

      // Overlay local read state on top of server data
      const merged = list.map((n) => ({
        ...n,
        is_read: n.is_read || readIds.has(n.id),
      }));

      setNotifications(merged);

      // Only alert for ones that are genuinely new AND unread
      const seenIds = new Set(
        JSON.parse(localStorage.getItem("notified_ids") || "[]"),
      );
      const toAlert = merged.filter((n) => !n.is_read && !seenIds.has(n.id));
      if (!toAlert.length) return;

      toAlert.forEach((n) => {
        seenIds.add(n.id);
        if (Notification.permission === "granted") {
          new Notification(n.title || "Notification", {
            body: n.message,
          });
        }
      });
      localStorage.setItem("notified_ids", JSON.stringify([...seenIds]));
    } catch (err) {
      console.error("Notification fetch error", err);
    }
  }, []);

  /* ------------------------------------------- POLLING ------------------------------------------ */
  useEffect(() => {
    Notification.requestPermission();
    fetchNotifications();

    const interval = setInterval(() => {
      if (!document.hidden) fetchNotifications();
    }, 15000);

    return () => clearInterval(interval);
  }, [fetchNotifications]);

  /* ------------------------------------------- OUTSIDE CLICK ----------------------------------- */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ---------------- ACTIONS ---------------- */
  const handleLogout = useCallback(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("role");
    nav("/");
  }, [nav]);

  const markAllRead = useCallback(() => {
    setNotifications((prev) => {
      const allIds = prev.map((n) => n.id);
      const existing = JSON.parse(
        localStorage.getItem("read_notification_ids") || "[]",
      );
      const merged = [...new Set([...existing, ...allIds])];
      localStorage.setItem("read_notification_ids", JSON.stringify(merged));

      return prev.map((n) => ({ ...n, is_read: true }));
    });
  }, []);

  const handleToggleNotifications = useCallback(() => {
    setShowNotifications((prev) => {
      const next = !prev;
      if (next) markAllRead();
      else setShowAll(false); // collapse back to top-4 view when closed
      return next;
    });
  }, [markAllRead]);

  return (
    <header className="inner-header">
      <div className="d-none d-xl-inline-flex inner-header__logo-block">
        <img
          src="./assets/images/inner-pages/layout/JigyaasuBlack_grayLogo.svg"
          alt="Logo"
          style={{ cursor: "pointer" }}
        />
      </div>

      <div className="inner-header__nav">
        {/* LEFT */}
        <div className="hi-block">
          <div className="hi-block__left">
            <img
              src="./assets/images/inner-pages/icons/icon-hand-hi.png"
              alt=""
            />
            <div className="text">
              <h4 className="fz28 mb-0 fw700">
                Hello <span className="m-hide">{fullName}</span>
              </h4>
              <p className="mb-0 fw500 fz16 ">Welcome to JIGYAASU</p>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="nav-right">
          {/* SEARCH */}
          <div className="position-relative form-group">
            <input
              type="text"
              className="border-0 fz18 fw500 form-control"
              placeholder="Search..."
              style={{
                padding: "12px 40px 12px 40px",
                height: "48px",
              }}
            />
            <img
              src="./assets/images/inner-pages/icons/icon-search.svg"
              alt=""
            />
          </div>

          {/* NOTIFICATION */}
          <div className="position-relative" ref={notificationRef}>
            <button
              className="btn btn-round btn-round--white"
              onClick={handleToggleNotifications}
            >
              <img
                src="./assets/images/inner-pages/icons/icon-notification-bell.svg"
                alt=""
              />
              {unreadCount > 0 && (
                <span className="notification-badge">{unreadCount}</span>
              )}
            </button>

            {showNotifications && (
              <div className="notification-modal">
                <div className="notification-header">
                  <h4>Notifications</h4>
                  {/* <button className="mark-read" onClick={markAllRead}>
                    Mark all as read
                  </button> */}
                </div>

                <div className="notification-list" style={{ zIndex: 999 }}>
                  {!notifications.length ? (
                    <p className="empty">No notifications</p>
                  ) : (
                    <>
                      {(showAll
                        ? notifications
                        : notifications.slice(0, 4)
                      ).map((item) => (
                        <div
                          key={item.id}
                          className={`notification-item ${item.is_read ? "read" : "unread"}`}
                        >
                          {item.title && <h5>{item.title}</h5>}
                          <p>{item.message}</p>
                          <span className="time">
                            {new Date(item.created_at).toLocaleString()}
                          </span>
                        </div>
                      ))}

                      {!showAll && notifications.length > 4 && (
                        <button
                          onClick={() => setShowAll(true)}
                          style={{
                            display: "block",
                            width: "100%",
                            marginTop: "8px",
                            padding: "10px 0",
                            background: "transparent",
                            border: "none",
                            borderTop: "1px solid #eee",
                            color: "#4a6cf7",
                            fontSize: "14px",
                            fontWeight: 600,
                            textAlign: "center",
                            cursor: "pointer",
                            borderRadius: "0 0 8px 8px",
                            transition: "background 0.15s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f5f7ff")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          See all ({notifications.length})
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* SMILEY */}
          <button
            className="btn btn-round btn-round--white"
            onClick={() =>
              setMood((prev) => (prev === "happy" ? "sad" : "happy"))
            }
          >
            <img
              src={
                mood === "happy"
                  ? "./assets/images/inner-pages/icons/icon-smiley.svg"
                  : "./assets/images/inner-pages/icons/sad1.png"
              }
              alt={mood === "happy" ? "Happy mood" : "Sad mood"}
            />
          </button>

          {/* USER */}
          <div className="hide-below-768 show-above-768 user">
            <img
              src="./assets/images/inner-pages/icons/icon-nav-user.svg"
              alt=""
            />

            <div className="dropdown">
              <button
                className="border-0 btn bg-transparent dropdown-toggle"
                data-bs-toggle="dropdown"
              >
                <div className="top">
                  <div className="fz20 fw500 name">{fullName}</div>
                  <img
                    src="./assets/images/inner-pages/icons/icon-dropdown-arrow.svg"
                    alt=""
                  />
                </div>
                {/* <p className="text-start mb-0 fz14">Your Recent Works</p> */}
                <p className="text-start mb-0 fz14">
                  {" "}
                  {role === 2
                    ? "Teacher"
                    : role === 1
                      ? "Student"
                      : "Admin"}{" "}
                </p>
              </button>

              <ul className="mt-2 dropdown-menu">
                {role === 3 ?
                  <li>
                    <button
                      className="dropdown-item"
                      disabled
                      onClick={() =>
                        role === 2
                          ? nav("/teacher-profile")
                          : nav("/userProfile")
                      }
                    >
                      My Profile
                    </button>
                  </li> :    <li>
                    <button
                      className="dropdown-item"
                      onClick={() =>
                        role === 2
                          ? nav("/teacher-profile")
                          : nav("/userProfile")
                      }
                    >
                      My Profile
                    </button>
                  </li>
                }

                <li>
                  <button className="dropdown-item" onClick={handleLogout}>
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderBar;
